import { LoyaltyCardRewardProps } from "components/atoms/LoyaltyCardReward/types";
import { Loyalty } from "types/Loyalty";
import { RANK_LEVEL_LOYALTY_IMAGES } from "../constants/loyalty";

enum VariantsImage {
  RANK = "rank",
  CLOSE = "close",
  EMPTY = "empty",
  PROGRESS = "progress",
}

export const getInfoRank = (
  nameRank?: string,
  cards?: LoyaltyCardRewardProps[],
  loyalty?: Loyalty,
  indexLevel?: string | number,
) => {
  if (!nameRank || !cards || !loyalty) {
    return {
      name: null,
      indexLevel: null,
      image: null,
    };
  }

  const indexRank = loyalty.settings?.ranks.findIndex(
    (rank) => rank.name === nameRank,
  );

  const images = RANK_LEVEL_LOYALTY_IMAGES[indexRank];
  let keyImage: string | null = null;
  const allRewardsClose =
    cards?.every((card) => card.content === "info") || false;
  const allRewardsIsGetting =
    cards?.every((card) => card.content === "completed") || false;
  const indexImage =
    indexLevel !== undefined && Number(indexLevel) > 2 ? 3 : indexLevel;

  if (allRewardsClose) {
    if (indexImage) {
      keyImage = VariantsImage.CLOSE + indexImage;
    } else {
      keyImage = VariantsImage.RANK;
    }
  } else if (allRewardsIsGetting) {
    if (indexImage) {
      keyImage = VariantsImage.EMPTY + indexImage;
    } else {
      keyImage = VariantsImage.RANK;
    }
  } else if (indexImage) {
    keyImage = VariantsImage.PROGRESS + indexImage;
  } else {
    keyImage = VariantsImage.RANK;
  }

  return {
    indexLevel,
    name: nameRank,
    image: images?.[keyImage],
    allRewardsIsGetting,
  };
};
